import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'
import { timersInMilliseconds } from '@/config/polling'

export const SELLER_AGREEMENTS = gql`
  query sellerAgreements($input: AgreementInput!) {
    agreements(input: $input) {
      id
      status
    }
  }
`

export const SELLER_AGREEMENTS_KEY = 'useSellerAgreements'

export const useSellerAgreements = (variables, options) =>
  useQuery({
    queryKey: [SELLER_AGREEMENTS_KEY, variables],
    queryFn: () => client.request(SELLER_AGREEMENTS, variables),
    staleTime: timersInMilliseconds.fiveMinutes,
    ...options,
  })
